// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"c4cd0fe0af17c01f","777":"27077e6514e59855"}[chunkId] + ".js";
};